import React, { Component } from 'react';
import { connect } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import userpic from '../../image/user1.png';
import authAction from '../../redux/auth/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import { Avatar } from 'antd';
import { siteConfig } from "../../settings";

const DEBUG = siteConfig.DEBUG
const { logout } = authAction;

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      userID: null,
      userImageUrl:null,
      communityID: null,
      communityName: null,
    };
  }
  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  componentWillMount () {
    DEBUG && console.log('componentDidMount');
    this.state.userToken = localStorage.getItem('access_token');
    DEBUG && console.log('UserToken: ' + this.state.userToken);

    this.state.userID = localStorage.getItem('userID');
    DEBUG && console.log('userID: ' + this.state.userID);

    this.state.userImageUrl = localStorage.getItem('userImageUrl');
    DEBUG && console.log('userImageUrl: ' + this.state.userImageUrl);

    this.state.communityID = localStorage.getItem('communityID');
    DEBUG && console.log('communityID: ' + this.state.communityID);

    this.state.communityName = localStorage.getItem('communityName');
    DEBUG && console.log('communityName: ' + this.state.communityName);

  }

  render() {
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        {/* <a className="isoDropdownLink" href="# ">
          <IntlMessages id="themeSwitcher.settings" />
        </a>
        <a className="isoDropdownLink" href="# ">
          <IntlMessages id="sidebar.feedback" />
        </a>
        <a className="isoDropdownLink" href="# ">
          <IntlMessages id="topbar.help" />
        </a> */}
        <a className="isoDropdownLink" onClick={this.props.logout} href="# ">
          <IntlMessages id="topbar.logout" />
        </a>
      </TopbarDropdownWrapper>
    );

    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        arrowPointAtCenter={true}
        placement="bottomLeft"
      >
        <div className="isoImgWrapper">
          {/* <img alt="user" src={userpic} /> */}
          <Avatar src ={localStorage.getItem('userImageUrl')} />
          <span className="userActivity online" />
        </div>
      </Popover>
    );
  }
}
export default connect(
  null,
  { logout }
)(TopbarUser);
